export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14430.db587991.jpg";